/*
 * SectionSubNavigationTab Specification
 * @module SectionSubNavigation
 * @flow
 */

import { withDevice } from '~/features/App/Device';

import { SectionSubNavigationTab as SST } from './SectionSubNavigationTab';

export const SectionSubNavigationTab = withDevice(SST);
